import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';

const Actions = ({ rowData, handleDeleteProperty }) => {
    const navigate = useNavigate();

    return (
        <span className="flex flex-row justify-center">
            <Tooltip
                title="ویرایش ویژگی"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => navigate("/properties/add-property", {
                        state: rowData
                    })}
                >
                    <EditIcon className="text-yellow-400" />
                </IconButton>
            </Tooltip>

            <Tooltip
                title="حذف ویژگی"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => handleDeleteProperty(rowData)}
                >
                    <DeleteIcon className="text-red-400" />
                </IconButton>
            </Tooltip>
        </span>
    );
}

export default Actions;
